{
  "es": {
    "company": {
      "actions": {
        "changeCompany": "Cambiar organización",
        "searchCompany": "Buscar organización"
      },
      "attributes": {
        "address": "Dirección",
        "email_address": "Correo electrónico",
        "iban": "IBAN",
        "language": "Idioma",
        "name": "Nombre de la organización",
        "phone": "Teléfono",
        "subdomain": "Subdominio",
        "vat": "IVA"
      },
      "labels": {
        "company": "Organización",
        "contact": "Contacto",
        "contacts": "Contactos",
        "language": "Este es el idioma predeterminado de la organización para tu página de inicio de sesión, los clientes y los empleados.",
        "or": "O"
      },
      "validation": {
        "contactAlreadyExist": "El contacto ya existe. Selecciónalo en el desplegable.",
        "mustBeEmailAddress": "Se requiere un correo válido",
        "needName": "El nombre es obligatorio"
      }
    }
  }
}
